import React from 'react';

// Simple CSS-based pie chart component
const PieChart = ({ data, height = '200px', colors = ['#3B82F6', '#10B981', '#F59E0B', '#8B5CF6', '#EF4444', '#06B6D4'] }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center" style={{ height }}>
        <p className="text-gray-500">No data available</p>
      </div>
    );
  }

  const total = data.reduce((sum, item) => sum + (item.value || 0), 0);
  
  if (total === 0) {
    return (
      <div className="flex items-center justify-center" style={{ height }}>
        <p className="text-gray-500">No data to display</p>
      </div>
    );
  }

  let cumulativePercentage = 0;

  return (
    <div className="space-y-4">
      <div className="relative" style={{ height, width: height, margin: '0 auto' }}>
        <svg viewBox="0 0 100 100" className="transform -rotate-90">
          {data.map((item, index) => {
            const value = item.value || 0;
            const percentage = (value / total) * 100;
            const startAngle = cumulativePercentage;
            const endAngle = cumulativePercentage + percentage;
            
            const startX = 50 + 50 * Math.cos((startAngle / 100) * 2 * Math.PI);
            const startY = 50 + 50 * Math.sin((startAngle / 100) * 2 * Math.PI);
            const endX = 50 + 50 * Math.cos((endAngle / 100) * 2 * Math.PI);
            const endY = 50 + 50 * Math.sin((endAngle / 100) * 2 * Math.PI);
            
            const largeArcFlag = percentage > 50 ? 1 : 0;
            
            const pathData = [
              `M 50 50`,
              `L ${startX} ${startY}`,
              `A 50 50 0 ${largeArcFlag} 1 ${endX} ${endY}`,
              'Z'
            ].join(' ');
            
            cumulativePercentage += percentage;
            
            return (
              <path
                key={index}
                d={pathData}
                fill={colors[index % colors.length]}
                stroke="white"
                strokeWidth="2"
                className="hover:opacity-80 transition-opacity"
                style={{ cursor: 'pointer' }}
                title={`${item.label}: ${value} (${percentage.toFixed(1)}%)`}
              />
            );
          })}
        </svg>
      </div>
      
      {/* Legend */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-4">
        {data.map((item, index) => {
          const value = item.value || 0;
          const percentage = (value / total) * 100;
          return (
            <div key={index} className="flex items-center space-x-2">
              <div
                className="w-4 h-4 rounded"
                style={{ backgroundColor: colors[index % colors.length] }}
              />
              <span className="text-sm text-gray-600 flex-1">{item.label}</span>
              <span className="text-sm font-semibold text-gray-800">
                {value} ({percentage.toFixed(1)}%)
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PieChart;

